export function makeEntityUid(prefix = 'uid') {
  const base = `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2,10)}`;
  return base.toLowerCase();
}

export function ensureAnimalRegistryFields(animal = {}, farmId = '') {
  const next = { ...(animal || {}) };
  next.registryUid = String(next.registryUid || next.animalUid || makeEntityUid('anr'));
  next.traceMode = String(next.traceMode || (next.microchip ? 'microchip' : 'individual'));
  next.currentPastureId = String(next.currentPastureId || next.pastureId || '');
  next.currentLotId = String(next.currentLotId || next.lotId || '');
  next.sourceLotId = String(next.sourceLotId || '');
  next.farmId = String(next.farmId || farmId || '');
  return next;
}

export function ensureLotRegistryFields(lot = {}, farmId = '') {
  const next = { ...(lot || {}) };
  next.registryUid = String(next.registryUid || next.lotUid || makeEntityUid('lot'));
  next.lotType = String(next.lotType || 'collective');
  next.currentPastureId = String(next.currentPastureId || next.pastureId || '');
  next.farmId = String(next.farmId || farmId || '');
  next.individualizedCount = Number(next.individualizedCount || 0);
  next.individualizationHistory = Array.isArray(next.individualizationHistory) ? next.individualizationHistory : [];
  next.selectedAnimalIds = Array.isArray(next.selectedAnimalIds) ? next.selectedAnimalIds.map(v=>String(v||'')).filter(Boolean) : [];
  return next;
}

export function createMicrochipAuditEvent({ farmId = '', animalUid = '', microchip = '', eventType = 'set', performedBy = '', notes = '' } = {}) {
  return {
    id: makeEntityUid('mca'),
    farmId: String(farmId || ''),
    animalUid: String(animalUid || ''),
    microchip: String(microchip || ''),
    eventType: String(eventType || 'set'),
    eventAt: new Date().toISOString(),
    performedBy: String(performedBy || ''),
    notes: String(notes || ''),
  };
}


export function createIndividualizationEvent({ farmId = '', sourceLot = {}, animalUid = '', qtyReduced = 1, performedBy = '', notes = '' } = {}) {
  return {
    id: makeEntityUid('ind'),
    farmId: String(farmId || sourceLot?.farmId || ''),
    sourceLotUid: String(sourceLot?.registryUid || sourceLot?.lotUid || sourceLot?.id || ''),
    createdAnimalUid: String(animalUid || ''),
    qtyReducedFromLot: Number(qtyReduced || 1),
    performedBy: String(performedBy || ''),
    performedAt: new Date().toISOString(),
    notes: String(notes || ''),
  };
}


export function ensureAnimalWeightEntry(entry = {}, farmId = "") {
  const next = { ...(entry || {}) };
  next.weightUid = String(next.weightUid || makeEntityUid("anw"));
  next.farmId = String(next.farmId || farmId || "");
  next.animalUid = String(next.animalUid || next.registryUid || "");
  next.weightKg = Number(next.weightKg || next.weight || 0);
  next.measuredAt = String(next.measuredAt || next.updatedAt || new Date().toISOString());
  return next;
}
